export const normalizedFileSize = (bytes) => {
  if (typeof bytes !== "number" || bytes < 1) {
    return "0 KB";
  }
  if (bytes < 1024 * 1024) {
    return Math.max(1, Math.round(bytes / 1024)) + " KB";
  }
  return (bytes / (1024 * 1024)).toFixed(1) + " MB";
};
